import OrderDetailPage from '@/pages/shared/OrderDetailPage'
import { aiFeatures } from '@/lib/aiFeatures'

export default function AdminOrderDetail() {
  return <OrderDetailPage basePath="/admin" can={{ shipment: true, partner: true, jobSheet: true, lifecycle: true, invoice: true, ai: aiFeatures.orderCheck }} />
}
